module.exports = __webpack_public_path__ + "img/harapan-jaya.45b615ba.png";